export default "__VITE_ASSET__CUReH4_$__"